// extracted by mini-css-extract-plugin
export var banner = "_cc-0";
export var closeButton = "_cc-2";
export var greenCheckmark = "_cc-3";
export var hereLink = "_cc-4";
export var titleIcon = "_cc-1";